import * as React from 'react'

import { DetailedPricing } from 'main/components/pricing'
import { ITuitionProgram } from 'main/gql/schoolTuitionProgram'
import { DetailedPricingModal_school } from '../../gql'
import PricingFeedbackForm from './PricingFeedbackForm'

import {
  Container,
  DetailedPricingContainer,
  PricingFeedbackFormContainer,
} from './ViewDetailedPricing.styles'

interface IProps {
  school: DetailedPricingModal_school
  tuitionPrograms: ITuitionProgram[]
}

export default function ViewDetailedPricing(props: IProps) {
  const { school, tuitionPrograms } = props

  return (
    <Container>
      <DetailedPricingContainer>
        <DetailedPricing
          tuitionPrograms={tuitionPrograms}
          tuitionBillingPolicy={school.tuitionBillingPolicy}
        />
      </DetailedPricingContainer>
      <PricingFeedbackFormContainer>
        <PricingFeedbackForm school={school} />
      </PricingFeedbackFormContainer>
    </Container>
  )
}
